import { Injectable } from "@angular/core";
import { LanguageDataEn } from "./assets/en";
import { LanguageDataZhChs } from "./assets/zh-CHS";
import { LanguageDataZhCht } from "./assets/zh-CHT";
import { TranslateDefaultParser, TranslateParser } from '@ngx-translate/core';

let languageSourceMap: Map<String,any> = new Map();
languageSourceMap.set("en",LanguageDataEn);
languageSourceMap.set("zh-CHS",LanguageDataZhChs);
languageSourceMap.set("zh-CHT",LanguageDataZhCht);

let currentLanguage: string = localStorage.getItem('languageCode');
if(!currentLanguage){
    currentLanguage = "zh-CHS";
}

let parser: TranslateParser = new TranslateDefaultParser();

export class I18nUtil {
    public static instant(key: string, param?: any): string {
      let statement = I18nUtil.getCurrentLangResource()[key];
      if (statement === undefined || statement === null) {
        return key;
      }

      let result = parser.interpolate(statement, param);
      if (result === undefined || result === null) {
        return key;
      }

      return result;
    }

    private static getCurrentLangResource() {
      return languageSourceMap.get(currentLanguage) || {};
    }
}

@Injectable({ providedIn: 'root' })
export class I18nService {

  constructor() {
  }

  public instant(key: string, param?: any): string {
    return I18nUtil.instant(key, param);
  }
}
